import Toast from "./Toast";
import { useToast } from "../../hook/useToast";

const ToastContainer = () => {
    const { toasts, removeToast } = useToast();

    if (!toasts || toasts.length === 0) {
        return null;
    }

    return (
        <div className="fixed top-16 right-4 z-[99999] space-y-2">
            {toasts.map((toast) => (
                <Toast key={toast.id} toast={toast} onRemove={removeToast} />
            ))}
        </div>
    );
};

export default ToastContainer;
